<template>
  <FlagTooltip
    :direction="direction"
    :items="tooltipItems"
    :originalLang="originalLang"
    :itemType="itemType"
    :showTags="showTags"
    v-on="errorClickListeners"
  >
    <div>
      <div class="d-flex align-center">
        <FlagCards
          :couple="couple"
          :items="getItemsCountryCode(tooltipItems[itemType].items)"
        />
      </div>
    </div>
    <template #actions>
      <slot name="actions"></slot>
    </template>
  </FlagTooltip>
</template>

<script>
import FlagTooltip from './FlagTooltip.vue'
import FlagCards from './FlagCards.vue'
import langCodes from '@/utils/langCodes.mixin.js'

export default {
  name: 'LanguageFlags',
  components: { FlagTooltip, FlagCards },
  mixins: [langCodes],
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemType: {
      type: String,
      required: true,
      validator: value => ['subtitles', 'dubbings', 'originalLang'].includes(value),
    },
    originalLang: {
      type: String,
      default: '',
    },
    direction: {
      type: String,
      default: 'bottom',
    },
    couple: {
      type: Boolean,
      default: false,
    },
    showTags: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltipItems() {
      if (!this.items || !this.items.length) {
        return {
          [this.itemType]: {
            label: this.getTranslationKey(),
            iconFile: this.itemType === 'subtitles' ? 'cc_tooltip' : 'dubbing',
            items: [],
          },
        }
      }
 
      return {
        [this.itemType]: {
          label: this.getTranslationKey(),
          iconFile: this.itemType === 'subtitles' ? 'cc_tooltip' : 'dubbing',
          items: this.items.map((item) => ({
            id: item.id,
            srclang: this.getPreparedSrcLang(item.srclang || item.lang),
            isAI: this.itemType === 'subtitles' 
              ? (item.transcription || item.translation)
              : (item.type === 'DUBBING' && item.status === 'SKIPPED') || item.type === 'GENERATED',
            hasError: item.status === 'ERROR' || item.status === 'FAILED',
            status: item.status,
            metadata: item.metadata,
            video_id: item.video_id,
            isLipsync: item.isLipsync,
            isUploaded: item.isUploaded,
            isOriginal: item.isOriginal,
          })),
        },
      }
    },
    errorClickListeners() {
      if (this.$listeners['error-click']) {
        return { 'error-click': (item) => this.$emit('error-click', item) }
      }
      return {}
    },
  },
  methods: {
    getItemsCountryCode(items) {
      if (!items || !items.length) return []
    
      const hasError = items.some((item) => item.hasError)
      if (hasError) return ['error']

      return items.map((item) => this.getCountryCodeBySrcLang(item.srclang))
    },
    getTranslationKey() {
      if (this.itemType === 'dubbings' && this.showTags) {
        return this.$i18next.t('message.ai.dubbings.audio')
      }
      const baseKey = `message.ai.${this.itemType}`
      return this.$i18next.t(this.itemType === 'originalLang' ? baseKey : `${baseKey}.${this.itemType}`)
    },
  },
}
</script>
